import {
  IPayrollChangeRequestData,
  IUserData,
  PayrollChangeRequestStatusEnum
} from '@/models';
import {
  IPayrollChangeRequestPaginatedListData,
  IPayrollChangeRequestService
} from './payrollchangerequest.types';
import { AxiosInstance } from 'axios';
import { Transition } from '@/models/transition';

export class PayrollChangeRequestService
  implements IPayrollChangeRequestService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/payroll-change-requests/';
  }

  fetchPayrollChangeRequests(
    page: number,
    search?: string,
    state?: number,
    self?: string
  ): Promise<IPayrollChangeRequestPaginatedListData> {
    return this.axios
      .get<IPayrollChangeRequestPaginatedListData>(`${this.endpoint}`, {
        timeout: 1 * (60 * 1000), //1 minute
        params: { page, search, state, self }
      })
      .then(({ data }) => data);
  }

  fetchPayrollChangeRequest(id: number): Promise<IPayrollChangeRequestData> {
    return this.axios
      .get<IPayrollChangeRequestData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createPayrollChangeRequest(
    data: IPayrollChangeRequestData
  ): Promise<IPayrollChangeRequestData> {
    return this.axios
      .post<IPayrollChangeRequestData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updatePayrollChangeRequest(
    data: IPayrollChangeRequestData
  ): Promise<IPayrollChangeRequestData> {
    return this.axios
      .patch<IPayrollChangeRequestData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deletePayrollChangeRequest(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  updatePayrollChangeRequestState(
    id: number,
    state: PayrollChangeRequestStatusEnum,
    assignee?: number
  ): Promise<IPayrollChangeRequestData> {
    return this.axios
      .put(`${this.endpoint}${id}/set_state/${state}/`, {
        assignee
      })
      .then(({ data }) => data);
  }

  fetchPayrollChangeRequestActivities(id: number): Promise<Transition[]> {
    return this.axios
      .get<Transition[]>(`${this.endpoint}${id}/activities/`)
      .then(({ data }) => data);
  }

  fetchPayrollChangeRequestHRPersonnels(id: number): Promise<IUserData[]> {
    return this.axios
      .get<IUserData[]>(`${this.endpoint}${id}/hr-personnels/`)
      .then(({ data }) => data);
  }

  exportPayrollChangeRequestPdf(requestId: number): Promise<Blob> {
    return this.axios
      .get(`${this.endpoint}${requestId}/export_pdf/`, {
        responseType: 'blob'
      })
      .then(({ data }) => data);
  }
}
